<div class="dialog-header">
  <h3 translate>mandatory-data-update-car-workshop-dialog.title</h3>
</div>

<div class="dialog-content" translate>
  mandatory-data-update-car-workshop-dialog.content
</div>

<div class="dialog-actions">
  <button mat-raised-button color="primary" (click)="onClickProceedButton()">
    {{ "mandatory-data-update-car-workshop-dialog.proceed-button" | translate }}
  </button>
</div>
